
import ProductList from "./ProductList";
import ProductCarousel from "./ProductCarousel";
import ProductBundleList from "./ProductBundleList";
import { slugify } from "~/utils";

export default {
  components: { ProductList, ProductCarousel, ProductBundleList },

  props: {
    slice: { type: Object, required: true },
    fetchState: { type: Object, required: true },
    products: { type: Array, default: () => [] },
    source: { type: String, default: "" },
    /** Set by VariationSearchspring for bundle PDP slice or legacy bundle-pdp tag. */
    isBundleVariation: { type: Boolean, default: false },
  },

  computed: {
    bundleQualifyingTags() {
      const raw = this.slice.primary?.qualifying_tags;
      if (!raw || typeof raw !== "string") return [];
      return raw
        .split(",")
        .map(t => t.trim())
        .filter(Boolean);
    },
    bundleOfferActive() {
      if (!this.isBundleType) return false;
      return this.products.some(product =>
        product.tags?.some(tag => this.bundleQualifyingTags.includes(tag))
      );
    },
    offerTitleHasContent() {
      return Boolean(
        this.$prismic.asText(this.slice.primary?.offer_title ?? [])?.trim()
      );
    },
    productsProps() {
      const base = {
        products: this.products.map(product => ({
          ...product,
          source: this.source,
        })),
      };
      if (this.isBundleType) {
        return {
          ...base,
          discount: Number(this.slice.primary?.discount) || 0,
          qualifyingTags: this.bundleQualifyingTags,
          pdpCallout: this.slice.primary?.pdp_callout?.trim() || "",
        };
      }
      return base;
    },
    listType() {
      return this.slice.primary?.list_type === false ? "gridList" : "carousel";
    },
    isBundleType() {
      return this.isBundleVariation || this.slice.primary?.tag === "bundle-pdp";
    },
    swiperClass() {
      const title = slugify(
        this.$prismic.asText(this.slice.primary.title) ?? ""
      );
      return `${title}-${this.source}-products-swiper`;
    },
  },

  watch: {
    products(value) {
      this.$store.dispatch("products/setRecommendedProduct", value?.[0]);
    },
  },
};
